const ECARD_TYPES = {
  INVITE: "invites",
  MAKE: "makes",
};

export { ECARD_TYPES };
